import { render, staticRenderFns } from "./TailwindAccordion.vue?vue&type=template&id=dbe45db0&"
import script from "./TailwindAccordion.vue?vue&type=script&lang=ts&"
export * from "./TailwindAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports